<template>
  <div
    class="my-nav-wrapper"
    :class="{
      'no-bg': noBg,
      transparent: transparent,
      whiteStyle: whiteStyle,
      iconWhite: iconWhite,
      'show-border': scrollY > 20 && showBorder,
    }"
  >
    <div class="my-nav full-w">
      <nuxt-link to="/" class="logo-wrapper">
        <Logo class="logo" @click="openMain"> </Logo>
      </nuxt-link>
      <div class="space-holder"></div>
      <div class="nav">
        <template v-for="item in menus">
          <div class="menu-item" :key="item.href">
            <nuxt-link v-if="!item.target" :to="item.href" class="menu-item-content" v-bury="item.bury">{{
              item.text.toLowerCase()
            }}</nuxt-link>
            <a v-else :href="item.href" class="menu-item-content" :target="item.target" v-bury="item.bury">{{
              item.text.toLowerCase()
            }}</a>
          </div>
        </template>
      </div>
      <div class="local">
        <div
          class="item"
          :class="{
            primary: $i18n.locale === 'zh',
          }"
          @click="$setLocale('zh')"
        >
          <span>中文</span>
        </div>
        |
        <div
          class="item"
          :class="{
            primary: $i18n.locale === 'en',
          }"
          @click="$setLocale('en')"
        >
          <span>EN</span>
        </div>
      </div>

      <!-- mobile menu -->
      <img class="nav-btn-mobile" src="//res-fengche.souche.com/f2e/6568d195529efbc96018a59a76c88f28.svg" @click="doShowMNav" />
      <div class="nav-menu-mobile" ref="nav-wrapper" @click.stop="doShowMNav">
        <div class="nav-menu-mobile-content" ref="nav-content">
          <img src="//res-fengche.souche.com/f2e/816b8c8e7e7a37ab3034850ac520baa0.svg" class="icon-close" @click.stop="doShowMNav" />
          <template v-for="item in menus">
            <div class="menu-item" :key="item.href">
              <nuxt-link v-if="!item.target" :to="item.href" class="menu-item-content" v-bury="item.bury">{{ item.text }}</nuxt-link>
              <a v-else :href="item.href" class="menu-item-content" :target="item.target" v-bury="item.bury">{{ item.text }}</a>
            </div>
          </template>
          <div class="ph"></div>
          <div class="lang">
            <span
              class="item"
              :class="{
                primary: $i18n.locale === 'zh',
              }"
              @click="$setLocale('zh')"
            >
              中文
            </span>
            |
            <span
              class="item"
              :class="{
                primary: $i18n.locale === 'en',
              }"
              @click="$setLocale('en')"
            >
              EN
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "./Logo.vue";
import gsap from "gsap";
export default {
  props: ["noBg", "fullWidth", "showBorder"],
  components: { Logo },
  data() {
    return {
      showNavSlider: false,
      scrollY: 0,
    };
  },
  watch: {
    showNavSlider: function () {
      const wrapperEl = this.$refs["nav-wrapper"];
      const contentEl = this.$refs["nav-content"];
      if (this.showNavSlider) {
        wrapperEl.style.transform = "translate3d(0%,0,0)";
        gsap.fromTo(
          wrapperEl,
          {
            backgroundColor: "rgba(0, 0, 0, 0)",
          },
          {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            duration: 0.2,
          }
        );
        gsap.fromTo(
          contentEl,
          {
            transform: "translate3d(100%,0,0)",
          },
          {
            transform: "translate3d(0%,0,0)",
            duration: 0.3,
            delay: 0.1,
          }
        );
      } else {
        gsap.fromTo(
          wrapperEl,
          {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          {
            backgroundColor: "rgba(0, 0, 0, 0)",
            delay: 0.1,
            duration: 0.2,
          }
        );
        gsap
          .fromTo(
            contentEl,
            {
              transform: "translate3d(0%,0,0)",
            },
            {
              transform: "translate3d(100%,0,0)",
              duration: 0.3,
            }
          )
          .eventCallback("onComplete", function () {
            wrapperEl.style.transform = "translate3d(100%,0,0)";
          });
      }
    },
  },
  computed: {
    transparent() {
      return this.$store.state.nav.transparent;
    },
    whiteStyle() {
      return this.$store.state.nav.whiteStyle;
    },
    iconWhite() {
      return this.$store.state.nav.iconWhite;
    },
    menus() {
      return [
        {
          text: this.$t("nav.home"),
          href: `/${this.$i18n.locale}/`,
          local: true,
        },
        {
          text: this.$t("nav.aboutUs"),
          href: `/${this.$i18n.locale}/html/about-us/`,
          local: true,
        },
        {
          text: this.$t("nav.products"),
          href: `/${this.$i18n.locale}/html/products/`,
          local: true,
        },
        {
          text: this.$t("nav.news"),
          href: `/${this.$i18n.locale}/html/news/`,
          local: true,
        },
        {
          text: this.$t("nav.INVESTORS"),
          href: 'https://ir.dasouche.com',
          target: '_blank',
        },
        {
          text: this.$t("nav.contactUs"),
          href: `/${this.$i18n.locale}/html/contact-us/`,
          local: true,
        },
      ];
    },
  },
  methods: {
    openMain() {
      window.location.href = `${location.protocol}//${location.host}`;
    },
    doShowMNav() {
      this.showNavSlider = !this.showNavSlider;
    },
    onScroll() {
      this.scrollY = window.scrollY;
    },
  },
  i18n: {
    messages: {
      zh: {
        nav: {
          home: "首页",
          aboutUs: "关于我们",
          products: "主营业务",
          news: "公司动态",
          contactUs: "联系我们",
          INVESTORS: "投资者关系",
        },
      },
      en: {
        nav: {
          home: "HOME",
          aboutUs: "ABOUT US",
          contactUs: "CONTACT US",
          products: "BUSINESS",
          news: "News & Events",
          INVESTORS: "Investor Relations",
        },
      },
    },
  },
};
</script>

<style lang="less" scoped>
.my-nav-wrapper {
  z-index: 12;
  transition: all 0.25s ease;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  background: #ffffff;
  width: 100vw;
}
.logo-wrapper {
  flex-shrink: 0;
  cursor: pointer;
}
.logo {
  width: 90px;
  fill: #ff571a;
  transition: fill ease 0.2s;
}
.transparent {
  position: fixed;
  background: transparent;
}

.local,
.menu-item-content {
  flex-shrink: 0;
  transition: color ease 0.2s;
}

.space-holder {
  flex: 1 1 auto;
}

@media screen and (min-width: 540px) {
  .whiteStyle {
    .menu-item-content {
      color: #ffffff !important;
    }

    .local {
      color: #ffffff !important;
    }
  }

  .iconWhite {
    .logo {
      fill: #ffffff;
    }
  }
}

.show-border {
  box-shadow: 1px 5px 12px #f4f1f0;
  border-radius: 4px;
  background: #ffffff;
  transition: all ease 0.2s;
}

.my-nav {
  box-sizing: border-box;
  max-width: var(--min-content-width);
  height: 100%;
  padding: 0 120px 0 120px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;

  .nav {
    flex-shrink: 0;
    cursor: pointer;
    display: flex;

    .menu-item {
      margin-left: 56px;
      min-width: 56px;
      display: flex;
      justify-content: center;

      .menu-item-content {
        float: left;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-decoration: none;
        position: relative;
        text-align: center;
        color: #000000;
        text-transform: uppercase;

        &:after {
          position: absolute;
          bottom: -3px;
          left: 0;
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          background: #ff571a;
          transition: transform 0.5s cubic-bezier(1, 0, 0, 1);
          transform: scale(0, 1);
          transform-origin: right top;
        }

        &:hover {
          &:after {
            transform: scale(1, 1) !important;
            transform-origin: left top !important;
          }
        }

        &.nuxt-link-active:not(:first-child) {
          &:after {
            transform: scale(1, 1);
            transform-origin: left top;
          }
        }
      }
      &:not(:first-child) .nuxt-link-active {
        &:after {
          transform: scale(1, 1);
          transform-origin: left top;
        }
      }
      &:first-child .nuxt-link-exact-active {
        &:after {
          transform: scale(1, 1);
          transform-origin: left top;
        }
      }
    }

    &:hover {
      .menu-item:not(:first-child) {
        &.nuxt-link-active {
          &:after {
            transform: scale(0, 1);
            transform-origin: right top;
          }
        }
      }
    }
  }

  .local {
    margin-left: 50px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-decoration: none;
    display: flex;
    cursor: none;
    color: #000000;

    .item {
      margin: 0 4px;
      cursor: pointer;
    }
  }

  .m-nav-btn {
    display: none;
  }
}

.full-w {
  max-width: 100vw;
}

.nav-btn-mobile,
.nav-menu-mobile {
  display: none;
}

/***************MOBILE******************/
@media screen and (max-width: 540px) {
  .my-nav-wrapper {
    height: 44px;

    .nav-btn-mobile {
      display: block;
      width: 44px;
      height: 44px;
      padding: 10px;
      box-sizing: border-box;
      overflow: hidden;
    }

    .nav-menu-mobile {
      display: block;
      flex-direction: column;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 100vh;
      height: 100dvh;
      text-align: right;
      background-color: rgba(0, 0, 0, 0);
      transform: translateX(100%);
      // transition: background-color 0.2s ease 0.3s;

      &-content {
        display: flex;
        flex-direction: column;
        width: 250px;
        height: 100%;
        overflow: hidden;
        background-color: white;
        transform: translateX(100%);
        // transition: transform 0.3s ease;
        margin-left: auto;
        align-items: center;

        .menu-item {
          margin-top: 30px;
          flex-shrink: 0;

          .nuxt-link-exact-active {
            color: #ff571a !important;
          }
        }

        .menu-item-content {
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 23px;
          text-align: center;
          color: #2b2c2e;
          text-decoration: none;
        }
        .ph {
          flex: 1;
          flex-grow: 1;
        }
        .lang {
          align-self: center;
          margin-bottom: 20px;
          flex-shrink: 0;
          margin-left: 0;
          font-weight: 400;
          font-size: 16px;
          line-height: 23px;
          text-align: center;
          color: #2b2c2e;

          & > .item {
            text-decoration: none;
          }
        }

        .icon-close {
          flex-shrink: 0;
          width: 44px;
          height: 44px;
          padding: 10px;
          box-sizing: border-box;
          display: block;
          align-self: flex-end;
          margin-right: 6px;
        }
      }
    }

    .nav,
    .local {
      display: none;
    }

    .my-nav {
      padding: 0 6px 0 16px;
    }

    .logo {
      width: 46px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyNav.vue